import { useQuery } from '@tanstack/react-query';
import { scheduleService } from '../../services/schedule.service';
import { queryKeys } from '../../lib/query-keys';

export function useSchedules(orgId: string | null) {
  return useQuery({
    queryKey: queryKeys.schedules.all(orgId ?? ''),
    queryFn: () => scheduleService.getSchedules(1, 100, undefined, orgId!),
    enabled: !!orgId,
    staleTime: 30_000,
    select: (res: any) => {
      const raw = res?.data ?? res;
      return Array.isArray(raw) ? raw : (raw?.data ?? []);
    },
  });
}

export function useAllScheduleTasks(scheduleIds: string[]) {
  return useQuery({
    queryKey: queryKeys.schedules.tasks(scheduleIds.join(',')),
    queryFn: async () => {
      const results = await Promise.all(
        scheduleIds.map(async (id) => {
          const res = await scheduleService.getScheduleTasks(id);
          const data = res.data || [];
          return Array.isArray(data)
            ? data.map((t: any) => ({ ...t, schedule_id: id }))
            : [];
        })
      );
      return results.flat();
    },
    enabled: scheduleIds.length > 0,
    staleTime: 30_000,
  });
}
